import { createFileRoute } from '@tanstack/react-router'
import { ErrorLanding } from '@components/ErrorLanding'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/')({
  component: Home,
})

function Home() {
  const { t } = useTranslation()

  return (
    <ErrorLanding
      heading={t('errorPage.general.heading')}
      subHeading={t('errorPage.landing.subheading')}
      description={t('errorPage.landing.description')}
      footer={t('errorPage.general.footer')}
    />
  )
}
